import { cn } from "@newxsystems/shared";
import { VelvetAction } from "../VelvetAction/VelvetAction";
import { VelvetMedia } from "../VelvetMedia/VelvetMedia";
import { VelvetRichText } from "../VelvetRichText/VelvetRichText";
import type { ICallToActionSplitProps } from "./CallToActionSplit.props";

const widths = { small: "md:w-2/3", medium: "md:w-5/6", large: "md:w-full" } as const;

export const CallToActionSplit = ({
  buttons,
  description,
  eyebrow,
  heading,
  image,
  imageWidth,
}: ICallToActionSplitProps) => (
  <div className="grid grid-cols-1 items-center gap-8 px-5 md:grid-cols-12 md:gap-x-8 md:gap-y-7 md:px-10">
    {eyebrow ? (
      <p className="velvet-datum order-1 font-velvet-body text-base italic text-thread md:col-span-6 md:col-start-1">
        {eyebrow}
      </p>
    ) : null}
    {image ? (
      <VelvetMedia
        aspectRatio={image.aspectRatio || "16:9"}
        className={cn(
          "velvet-arch order-2 w-full justify-self-end border border-parchment/20 md:col-span-5 md:col-start-8 md:row-span-4 md:row-start-1",
          widths[imageWidth || "medium"],
        )}
        media={image.image}
        sizes="(min-width: 768px) 50vw, 100vw"
      />
    ) : null}
    {heading ? (
      <h2 className="order-3 font-velvet-display text-6xl font-black uppercase leading-[0.82] tracking-[-0.04em] [overflow-wrap:anywhere] md:col-span-7 md:col-start-1 md:text-8xl">
        {heading}
      </h2>
    ) : null}
    {description ? (
      <VelvetRichText
        className="order-4 max-w-[65ch] text-bone md:col-span-5 md:col-start-1"
        content={description}
      />
    ) : null}
    {buttons?.length ? (
      <div
        className={cn(
          "order-5 flex flex-wrap gap-3",
          image
            ? "md:col-span-6 md:col-start-1"
            : "md:col-span-5 md:col-start-8 md:row-span-3 md:row-start-1 md:justify-self-end",
        )}
      >
        {buttons.map((button, index) => (
          <VelvetAction action={button} className="border-bone" key={`${button.href}-${index}`} />
        ))}
      </div>
    ) : null}
  </div>
);

CallToActionSplit.displayName = "Content::CallToActionSplit";
